import { List } from 'immutable'
import _toNumber from 'lodash/toNumber'
import _round from 'lodash/round'
import _isFinite from 'lodash/isFinite'
import { PLAN_CATEGORY_ANNUAL, PLAN_CATEGORY_GAIA_PLUS } from '../plans/index'

/**
 * Format the marketing value for the checkout order (System A).
 * Lockstep with gaia-brooklyn-api format-checkout-order-marketing-value.ts.
 *
 * System A rules:
 * - 3-month list-price proxy for ad-network conversion value (not cash, not LTV, not System B GTM).
 * - Annual / Gaia+: `(price/12)*3`, halved when `costs[0]===0` (free-trial start).
 * - Other tiers: `price*3`, halved on free-trial start.
 * - Ads workers use this value; GA4 MP (later) uses billing `amount` instead — never swap.
 *
 * @param {import('immutable').Map} selectedPlan - The selected plan
 * @returns {number} The marketing value
 */
// eslint-disable-next-line import/prefer-default-export
export function formatCheckoutOrderMarketingValue (selectedPlan) {
  const planCategory = selectedPlan.get('type')
  const costs = selectedPlan.get('costs', List()) || List()
  const firstCost = _toNumber(costs.first())
  const lastCost = _toNumber(costs.last())
  const price = firstCost || lastCost
  let value = 0

  if (costs.size === 0 || !_isFinite(price)) {
    return value
  }

  if (planCategory === PLAN_CATEGORY_ANNUAL || planCategory === PLAN_CATEGORY_GAIA_PLUS) {
    value = firstCost === 0 ? ((price / 12) * 3) * 0.5 : (price / 12) * 3
  } else {
    value = firstCost === 0 ? ((price * 3) * 0.5) : (price * 3)
  }

  return _round(value, 2)
}
